export default "__VITE_ASSET__CVmcXYcr__"